import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getControlGroup } from '../Api'

export default generateApiAction({
  baseType: Types.CTRL_GROUPS.GET,
  api: getControlGroup,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/controlGroups/GetAction.js